export default "__VITE_ASSET__FvA_fwzb__"